// extracted by mini-css-extract-plugin
module.exports = {"event-btn":"editor_editContent_event-btn__yqFVm","edit-form":"editor_editContent_edit-form__3uUhb","section-title":"editor_editContent_section-title__OQ7bj"};